// Well spawn configuration.
//
// These values are centralized so you can tune the Well system
// without digging through map generation or UI code.

// The earliest floor a well can appear on.
export const WELL_MIN_FLOOR = 3;

// Per-floor chance that EXACTLY ONE well attempt is made.
// (If placement fails due to map constraints, no well will appear.)
export const WELL_SPAWN_CHANCE_PER_FLOOR = 0.50;
